module.exports = __webpack_public_path__ + "fonts/BaskervilleBT-BoldItalic.c6947668.woff";